import ApiService from "../../../services/api.service";

const MxikService = {
	getList(search, payload) {
		return ApiService.post(`/mxik-code/search?search=${search}`, payload)
	},
	create(data) {
		return ApiService.post(`/mxik-code/create`, data)
	},
	update(data) {
		return ApiService.put(`/mxik-code/update/${data.id}`, data)
	},
	delete(id) {
		return ApiService.delete(`/mxik-code/delete/${id}`)
	}
}

export default MxikService
